import React, { useState, useEffect } from 'react';
import { auth, db } from './firebase';
import { onAuthStateChanged } from 'firebase/auth';
import { collection, query, where, getDocs } from 'firebase/firestore';
import AuthScreen from './components/AuthScreen';
import Sidebar from './components/Sidebar';
import DashboardTab from './components/DashboardTab';
import TodaysJobsTab from './components/TodaysJobsTab';
import ScheduleTab from './components/ScheduleTab';
import ServicesTab from './components/ServicesTab';
import LocationsTab from './components/LocationsTab';
import DriverCoordinationTab from './components/DriverCoordinationTab';
import PaymentsTab from './components/PaymentsTab';
import ReportsTab from './components/ReportsTab';
import BusinessProfileTab from './components/BusinessProfileTab';
import TeamMembersTab from './components/TeamMembersTab';
import SettingsTab from './components/SettingsTab';

export default function App() {
  const [user, setUser]             = useState(null);
  const [loading, setLoading]       = useState(true);
  const [activeTab, setActiveTab]   = useState('dashboard');
  const [centerData, setCenterData] = useState(null);
  const [centers, setCenters]       = useState([]);

  useEffect(() => {
    const unsub = onAuthStateChanged(auth, async (u) => {
      setUser(u);
      if (u) await loadCenterData(u.uid);
      setLoading(false);
    });
    return unsub;
  }, []);

  const loadCenterData = async (uid) => {
    try {
      const q = query(collection(db, 'serviceCenters'), where('primaryOwnerUid', '==', uid));
      const snap = await getDocs(q);
      if (!snap.empty) {
        const list = snap.docs.map(d => ({ id: d.id, ...d.data() }));
        setCenters(list);
        setCenterData(list[0]);
      }
    } catch (e) { console.error(e); }
  };

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh' }}>
      <div style={{ textAlign: 'center' }}>
        <div style={{ fontSize: 28, fontWeight: 900, marginBottom: 8 }}>Coco<span style={{ color: '#F97316' }}>Wash</span></div>
        <div style={{ color: '#6b7280' }}>Loading portal...</div>
      </div>
    </div>
  );

  if (!user) return <AuthScreen />;

  const TABS = {
    dashboard:  <DashboardTab  user={user} centerData={centerData} centers={centers} />,
    todaysjobs: <TodaysJobsTab user={user} centerData={centerData} />,
    schedule:   <ScheduleTab   user={user} centerData={centerData} />,
    services:   <ServicesTab   user={user} centerData={centerData} onRefresh={() => loadCenterData(user.uid)} />,
    locations:  <LocationsTab  user={user} centers={centers} onRefresh={() => loadCenterData(user.uid)} />,
    drivers:    <DriverCoordinationTab user={user} centerData={centerData} />,
    payments:   <PaymentsTab   user={user} centerData={centerData} />,
    reports:    <ReportsTab    user={user} centerData={centerData} />,
    profile:    <BusinessProfileTab user={user} centerData={centerData} onRefresh={() => loadCenterData(user.uid)} />,
    team:       <TeamMembersTab user={user} centerData={centerData} />,
    settings:   <SettingsTab   user={user} centerData={centerData} />,
  };

  return (
    <div style={{ display: 'flex', height: '100vh', overflow: 'hidden' }}>
      <Sidebar activeTab={activeTab} setActiveTab={setActiveTab} user={user} centerData={centerData} />
      <main style={{ flex: 1, overflowY: 'auto', backgroundColor: '#f8f9fa' }}>
        {TABS[activeTab] || TABS['dashboard']}
      </main>
    </div>
  );
}
